export var CustomModelPublishedState;
(function (CustomModelPublishedState) {
    CustomModelPublishedState["NEVER"] = "never";
    CustomModelPublishedState["PUBLISHED"] = "published";
    CustomModelPublishedState["UNPUBLISHED"] = "unpublished";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["DRAFT"] = "draft";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["READY"] = "ready";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["QUEUED"] = "queued";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["TRAINING"] = "training";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["FAILED"] = "failed";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["CANCELLED"] = "cancelled";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["ALL"] = "all";
})(CustomModelPublishedState || (CustomModelPublishedState = {}));
export var CustomModelOrderBy;
(function (CustomModelOrderBy) {
    CustomModelOrderBy["MODIFY_DATE"] = "modified_date";
    CustomModelOrderBy["CREATE_DATE"] = "created_date";
    CustomModelOrderBy["NAME"] = "name";
})(CustomModelOrderBy || (CustomModelOrderBy = {}));
